export const getSr = state => state.searchFilters.sr;

export const getSelectedImageryCapabilities = state =>
  state.searchFilters.selectedImageryCapabilities;
